import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ConfigProvider } from "@/context/ConfigContext";
import { Toaster } from "@/components/ui/sonner";
import { ScrollToTop } from "@/components/ScrollToTop";

import Home from "@/pages/Home";
import SimulateurMutuelle from "@/pages/SimulateurMutuelle";
import SimulateurExpat from "@/pages/SimulateurExpat";
import Verification from "@/pages/Verification";
import Results from "@/pages/Results";
import SeoPage, { SEO_PAGES } from "@/pages/SeoPage";
import { MentionsLegales, Confidentialite } from "@/pages/Legal";
import Contact from "@/pages/Contact";

import { RequireAuth } from "@/components/crm/RequireAuth";
import Login from "@/pages/crm/Login";
import Dashboard from "@/pages/crm/Dashboard";
import Prospects from "@/pages/crm/Prospects";
import ProspectDetail from "@/pages/crm/ProspectDetail";
import Pipeline from "@/pages/crm/Pipeline";
import Insurers from "@/pages/crm/Insurers";
import Tasks from "@/pages/crm/Tasks";
import Users from "@/pages/crm/Users";
import Settings from "@/pages/crm/Settings";

function App() {
  return (
    <div className="App">
      <ConfigProvider>
        <AuthProvider>
          <BrowserRouter>
            <ScrollToTop />
            <Routes>
              {/* Public */}
              <Route path="/" element={<Home />} />
              <Route path="/simulateur/mutuelle-france" element={<SimulateurMutuelle />} />
              <Route path="/simulateur/assurance-expat" element={<SimulateurExpat />} />
              <Route path="/verification" element={<Verification />} />
              <Route path="/resultats/:prospect_id" element={<Results />} />
              <Route path="/mentions-legales" element={<MentionsLegales />} />
              <Route path="/confidentialite" element={<Confidentialite />} />
              <Route path="/contact" element={<Contact />} />
              {Object.keys(SEO_PAGES).map((slug) => (
                <Route key={slug} path={`/${slug}`} element={<SeoPage slug={slug} />} />
              ))}

              {/* CRM */}
              <Route path="/espace-courtier" element={<Login />} />
              <Route path="/espace-courtier/tableau-de-bord" element={<RequireAuth><Dashboard /></RequireAuth>} />
              <Route path="/espace-courtier/prospects" element={<RequireAuth><Prospects /></RequireAuth>} />
              <Route path="/espace-courtier/prospects/:id" element={<RequireAuth><ProspectDetail /></RequireAuth>} />
              <Route path="/espace-courtier/pipeline" element={<RequireAuth><Pipeline /></RequireAuth>} />
              <Route path="/espace-courtier/taches" element={<RequireAuth><Tasks /></RequireAuth>} />
              <Route path="/espace-courtier/assureurs" element={<RequireAuth><Insurers /></RequireAuth>} />
              <Route path="/espace-courtier/utilisateurs" element={<RequireAuth><Users /></RequireAuth>} />
              <Route path="/espace-courtier/parametres" element={<RequireAuth><Settings /></RequireAuth>} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" richColors />
        </AuthProvider>
      </ConfigProvider>
    </div>
  );
}

export default App;
